import { render, staticRenderFns } from "./form-submission-star-rating-field.vue?vue&type=template&id=56f319a0"
import script from "./form-submission-star-rating-field.vue?vue&type=script&lang=js"
export * from "./form-submission-star-rating-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports